import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function PlusLine({ color = 'icon.primary', stroke = 2, ...props }) {
  return (
    <IconBase viewBox='0 0 31 31' {...props}>
      <Path
        d='M15.4666 28L15.4666 3'
        stroke={color}
        strokeWidth={stroke}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M28 15.4844L3 15.4844'
        stroke={color}
        strokeWidth={stroke}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </IconBase>
  )
}

PlusLine.propTypes = {
  color: PropTypes.string,
  stroke: PropTypes.number,
}

export default PlusLine
